module.exports = __webpack_public_path__ + "img/bg.5b8e28e6.jpg";